<template>
  <header class="" id="header-main">
    <nav class="navbar navbar-main navbar-expand-lg shadow navbar-dark bg-dark" id="navbar-main">
      <div class="container">
        <button class="navbar-toggler order-lg-2 ml-n3 ml-lg-0" type="button" data-toggle="collapse"
                data-target="#navbar-main-collapse" aria-controls="navbar-main-collapse" aria-expanded="false"
                aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse navbar-collapse-overlay order-lg-3" id="navbar-main-collapse">
          <div class="position-relative">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-main-collapse"
                    aria-controls="navbar-main-collapse" aria-expanded="false" aria-label="Toggle navigation">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-x">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <ul class="navbar-nav mr-3">
            <li v-for="item in filterMenuItems(menu)" :key="item.route" class="nav-item nav-item-spaced d-lg-block">
              <router-link
                class="nav-link"
                :active-class="''"
                :exact-active-class="''"
                :to="{name: item.route}"
              >
                {{ item.title }}
              </router-link>

            </li>
          </ul>
          <ul class="navbar-nav align-items-lg-center d-lg-flex ml-lg-auto">
            <li v-if="this.getUser" class="nav-item nav-item-spaced d-lg-block">
                <span>Balance: {{ this.getUser.account.formatted }}</span>
            </li>
            <li class="nav-item nav-item-spaced d-lg-block">
              <a @click.prevent="doLogout()" class="nav-link" href="#">Log out
                ({{ this.getUser ? this.getUser.username : '' }})</a>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  </header>


</template>

<style scoped>

.nav-link.router-link-exact-active {
  background-color: rgba(255, 255, 255, .1);
  color: #fff;
}

</style>

<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getUser'
    ]),
    menu() {
      return [
        {
          route: 'homepage', title: 'Play'
        },
      ]
    }
  },
  methods: {
    navItemClass: function (item) {
      if (item.type === 'item') {
        return '';
      }
      for (let index in item.items) {
        if (item.items[index].route === this.$route.name) {
          return 'menu-open';
        }
      }
      return '';
    },
    filterMenuItems: function (items) {
      return items.filter(item => this.hasAccess(item));
    },
    doLogout: function () {
      this.$store.dispatch('logout');
    },
    hasAccess(item) {
      return true;
    },
  },
  mounted() {
  },
};
</script>
